import axios from 'axios'

export class Session {
    id            = undefined
    token         =  undefined
    client        = undefined
    clientId      = undefined
    corporationId = undefined
    created       = undefined
    refreshed     = undefined
    user          = undefined
    userId        = undefined
    refreshing    = false
    available     = false
}

export default class TowsSessionHandler {
    _client           = undefined
    _coporationId     = undefined
    _middlewareUrl    = undefined
    _timeout          = undefined
    _session          = undefined

    /**
     * Constructs the sessionHandler
     *
     * @param {string} client TOWS client-abbreviation
     * @param {string} corporationId TOWS coporation identifier (KTNR)
     * @param {string} middlewareUrl url where the session service is located
     */
    constructor(client, coporationId, middlewareUrl) {
        if (!middlewareUrl) {
            throw 'no-middleware'
        }

        if (!client) {
            throw 'no-client'
        }

        if (!coporationId) {
            console.log('no-corporation')
        }

        this._client           = client
        this._coporationId     = coporationId
        this._middlewareUrl    = middlewareUrl
    }

    /**
     * creates a connection to the tows and retreives a session
     *
     * @param {number} [refreshSessionAfterSeconds = 600] - Time in seconds after which the session is refreshed (default: 600 -> 10min)
     */
    async connect({ refreshSessionAfterSeconds = 600 } = {}) {
        // timeout accepts value in ms
        this._timeout = refreshSessionAfterSeconds * 1000
        return this._getSession()
    }

    /**
     * Private function that establishes the first connection and triggers the refresh
     * USES CLASS-GLOBAL PROPERTIES
     *
     * @returns {reactive} Reactive session object
     */
    async _getSession() {
        const session = new Session()
        session.refreshing = true

        let sessionUrl = this._middlewareUrl
        sessionUrl += '/rest/session'
        sessionUrl += '?client=' + this._client
        sessionUrl += '&corporation=' + this._coporationId

        return axios.get(sessionUrl)
        .then(response => {
            const data = response.data

            session.token         = data.token
            session.id            = data.session
            session.client        = data.client
            session.clientId      = data.clientId
            session.user          = data.user
            session.userId        = data.userId
            session.created       = data.created
            // this._session.corporationId = data.corporationid ?
            session.refreshed     = new Date()
            session.refreshing    = false
            session.available     = true

            // start the refresh cycle
            setTimeout(() => this._getSession(), this._timeout)

            return session
        })
    }

    async getSystemConfiguration(clientId) {
        let configurationUrl = this._middlewareUrl
        configurationUrl += '/clients/' + clientId
        configurationUrl += '/systemconfiguration'

        return axios.get(configurationUrl)
        .then(response => {
            const body = response.data
    
            if (body.status.ErrorCode !== 0) {
                throw body.statuts.ErrorMsg
            }

            const configuration = {}
    
            configuration.configuration   = body.data.configuration
            configuration.legallinklist   = body.data.legallinklist
            configuration.linklist        = body.data.linklist
            configuration.startpoints     = body.data.startpoints
            configuration.anlageassistent = body.data.anlageassistent
    
            return configuration
        })
    }

    async getClientLogo(clientId) {
        let configurationUrl = this._middlewareUrl
        configurationUrl += '/clients/' + clientId
        configurationUrl += '/logo'

        return axios.get(configurationUrl)
        .then(response => {
            const body = response.data
    
            if (body.status.ErrorCode !== 0) {
                throw body.statuts.ErrorMsg
            }

            const clientlogo = {
                dataUri : body.data.logo
            } 
    
            return clientlogo
        })
    }    

    async getBaseData(clientId) {
        const baseData = {
            salutations:        [],
            titles:             [],
            countries:          [],
            terminationReasons: []
        }

        let salutationsUrl = this._middlewareUrl
        salutationsUrl += '/basedata/salutations'
        const salutationsPromise = axios.get(salutationsUrl)

        let titlesUrl = this._middlewareUrl
        titlesUrl += '/basedata/titles'
        const titlesPromise = axios.get(titlesUrl)

        let countriesUrl = this._middlewareUrl
        countriesUrl += '/basedata/countries'
        const countriesPromise = axios.get(countriesUrl)

        let terminationReasonsUrl = this._middlewareUrl
        terminationReasonsUrl += '/clients/' + clientId
        terminationReasonsUrl += '/termination-reasons'
        const terminateionReasonsPromise = axios.get(terminationReasonsUrl)

        let replacementReasonsUrl = this._middlewareUrl
        replacementReasonsUrl += '/clients/' + clientId
        replacementReasonsUrl += '/replacement-reasons'
        const replacementReasonsPromise = axios.get(replacementReasonsUrl)

        return Promise.all([salutationsPromise, titlesPromise, countriesPromise, terminateionReasonsPromise, replacementReasonsPromise])
        .then(responses => {
            responses.forEach(response => {
                const requestUrl = response.request.responseURL
                const data = response.data.data

                if (requestUrl.includes(salutationsUrl)) {
                    baseData.salutations = data.salutationlist.map(entry => {
                        return {
                            displayid:   entry.IDAnrede,
                            displayname: entry.AnredeText
                        }
                    })
                } else if (requestUrl.includes(titlesUrl)) {
                    baseData.titles = data.titlelist.map(entry => {
                        return {
                            displayid:   entry.IDTitel,
                            displayname: entry.TitelText
                        }
                    })
                } else if (requestUrl.includes(countriesUrl)) {
                    baseData.countries = data
                } else if (requestUrl.includes(terminationReasonsUrl)) {
                    baseData.terminationReasons = data.reasons.map(entry => {
                        return {
                            displayid:   entry.IDKuendigungsgrund,
                            displayname: entry.KundigungsgrundText
                        }
                    })
                } else if (requestUrl.includes(replacementReasonsUrl)) {
                    baseData.replacementReasons = data.reasons.map(entry => {
                        return {
                            displayid:   entry.IDGrund,
                            displayname: entry.Bezeichnung
                        }
                    })
                }
            })

            return baseData
        })
    }
}